export const areas: Record<string, string> = {
	area_base_archives: "Base archives",
	area_base_level: "Base level $1",
	area_caves: "Caves level $1",
	area_cursed_caves: "Cursed Caves $1",
	area_cursed_wasteland: "Cursed Wastelands $1",
	area_robot_base: "Robot Base",
	area_sealed_passage: "Sealed Passage",
	area_tutorial_1: "Tutorial Level 1",
	area_tutorial_2: "Tutorial Level 2",
	area_tutorial_3: "Tutorial Level 3",
	area_tutorial_4: "Tutorial Level 4",
	area_wasteland: "Wasteland",
	area_wasteland_level: "Wastelands level $1",
	area_branch_cave: "Branch Cave",
	area_power_plant_level: "Power plant level $1",
	area_power_plant_underground: "Power plant underground $1",
};
